export default __webpack_public_path__ + "static/media/double-border-left.2ba2cf2c.svg";